import React from "react";
import { StyleSheet, Text, View, TouchableOpacity, Image, KeyboardAvoidingView } from "react-native";
import AppStyles from "../../AppStyles";
import AppTheme from "../../AppTheme";
import { store } from "../../store/store";
import { debounce } from "lodash"
import { doPost } from "../../utils/services/api/API";
import * as Redux from "../../utils/services/redux/commonRedux";
import ImagePicker from "../../utils/widgets/questionTypes/ImagePicker";
import ImageWithPointer from "../../utils/widgets/questionTypes/ImageWithPointer";
import InputFeildFunc from "../../utils/widgets/questionTypes/InputFeildFunc";
import MultipleChoiceFunc from "../../utils/widgets/questionTypes/MultipleChoiceFunc";
import SingleChoiceFunc from "../../utils/widgets/questionTypes/SingleChoiceFunc";
import * as AlertService from "../../utils/services/AlertLoaderService";
import * as MoengageUtils from "../../utils/services/webapp-services/MoengageUtils";
import InputFeildWithNAFunc from "../../utils/widgets/questionTypes/InputFeildWithNAFunc";
import { AppAPIVersion, AppUIVersion } from "../../utils/constants/AppConstants";
import GestureRecognizer from 'react-native-swipe-gestures';
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { ScreenRoute } from "../../utils/constants/ScreenRouteConstant";
import { backpressBheaviour$, commonModalData$ } from "../../utils/services/subject-behaviour/CommonRxjsService";
import ActionPopup from "../../utils/modals/ActionPopup";
import ModalContent from "../../utils/constants/ModalContentConstant";
import { handleModalBackpress } from "../CommonService";

import { addFontFamilylato, getImagePath } from "../../utils/services/CommonUtils";
import {
    setConsultationAnswer, getConsultationAnsValue, checkSubsIDExist,
    getConsultationAnsTextInputValue, getConsultationAnswer
} from "../../utils/services/econsult/EConsultUtils"

export default class QuestionaireScreen extends React.Component<any, any> {

    unsubscribe: any;
    constructor(props) {
        super(props);
        const reduxState = store.getState();
        this.state = {
            consultationParams: reduxState.consultationParams ?? {},
            questionList: reduxState.consultationQuestion ?? [],
            answerList: reduxState.consultationAnswer ?? {},
            ansList: reduxState.consultationAnswer ?? {},
            qType: '',
            qData: {},
            ansData: {},
            enableNextQ: false,
            enablePreviousQ: false,
            hasSubqs: false,
            subqOption: '',
            render: false,
            fromReview: false,
            currentIndex: 0,
            lastQId: '99',
            dataVersion: 0,
            bodyTags: [],

            showExitFlowPopup: false
        }
        this.unsubscribe = store.subscribe(() => {
            const reduxState = store.getState();
            if (this.state.render)
                this.checkAnswerInput(reduxState.currentConsultationQuestion,
                    reduxState.currentConsultationAnswer)
        })
    }

    exitFlowAction = () => {
        // window.history.pushState(null, '', getPushStateUri(window.location.origin) + location.pathname);
        this.props.navigation.pop();
        // this.setExitFlowPopup({ active: false })
    }

    setExitFlowPopup = (modalData) => {
        handleModalBackpress(modalData, {
            showModal: this.state.showExitFlowPopup,
            setModal: (showPopup) => { this.setState({ showExitFlowPopup: showPopup }) },
            modalDataSubscriber: this.modalDataSubscriber
        })
    }

    modalDataSubscriber = debounce((modalData) =>
        commonModalData$.next({ active: modalData.active }), 200)

    componentDidMount() {
        const reduxState = store.getState();

        if (reduxState.consultationQuestion.length == 0)
            this.consultationAPI('questions/start', {
                'caseCode': reduxState.consultationParams['selectedCategory']['caseCode'],
                'userId': reduxState.consultationParams['selectedMember']['id']
            });
        else {
            this.setState({
                fromReview: true,
                enableNextQ: true,
                lastQId: this.getReviewLastQId(reduxState.currentConsultationQuestion, reduxState.currentConsultationAnswer),
                enablePreviousQ: false,
                questionList: reduxState.consultationQuestion,
                answerList: reduxState.consultationAnswer,
                ansList: reduxState.consultationAnswer,
                qData: reduxState.currentConsultationQuestion,
                ansData: reduxState.currentConsultationAnswer,
                qType: reduxState.currentConsultationQuestion['qtype'],
                currentIndex: this.getCurrentReviewQuestionIndex(reduxState.consultationQuestion, reduxState.currentConsultationQuestion),
                render: true
            })
        }

        backpressBheaviour$.subscribe((backpressData) => {
            if (backpressData.backpressData['questionaireFlowExit'])
                this.setExitFlowPopup({ active: true })
        })
    }

    componentWillUnmount() {
        // cancel to store.subscribe
        this.setState({ render: false })
        this.unsubscribe();
    }

    checkSubqsAPICall() {
        this.setState({ render: false });
        const qData = this.getCurrentQ();
        let dataVersion: any = localStorage.getItem('dataVersion');
        var response = this.removeSubsAnswer();
        if (response.hasSubqs)
            this.consultationAPI('questions/next', {
                ln: 'en',
                uiVersion: AppUIVersion,
                apiVersion: AppAPIVersion,
                dataVersion: JSON.parse(dataVersion),
                caseCode: this.state.consultationParams.selectedCategory.caseCode,
                userId: this.state.consultationParams.selectedMember.id,
                qid: qData['qid'],
                selectedOptions: [this.state.subqOption],
            });
        else this.moveToNextQuestion(response.qList, response.ansList, response.lastQId);

        // this.state.hasSubqs ?
        //     this.consultationAPI('questions/next', {
        //         ln: 'en',
        //         uiVersion: AppUIVersion,
        //         apiVersion: AppAPIVersion,
        //         dataVersion: JSON.parse(dataVersion),
        //         caseCode: this.state.consultationParams.selectedCategory.caseCode,
        //         userId: this.state.consultationParams.selectedMember.id,
        //         qid: qData['qid'],
        //         selectedOptions: [getConsultationAnsValue(qData, ansData)],
        //     }) : this.state.fromReview ? this.updateReviewAnswer() :
        //         this.moveToNextQuestion();
    }

    consultationAPI(urn: String, params: Object, hasSubq = this.state.hasSubqs) {
        this.setState({ render: false });
        AlertService.loaderModal.setLoader(true, 0.6)
        params['ln'] = 'en';
        params['uiVersion'] = AppUIVersion;
        params['apiVersion'] = AppAPIVersion;
        doPost(urn, params).then(
            (response: any) => {
                hasSubq ? this.populateSubQuestionsAndMoveToNext(response.questions) :
                    this.updateQuestionData(response.questions, response.dataVersion, response.bodyTags);
                AlertService.loaderModal.setLoader(false);
                this.setState({ render: true });
            },
            (error: any) => {
                console.log(error);
                AlertService.loaderModal.setLoader(false)
                this.props.navigation.pop();
            }
        )
    }

    formatAnswerList(ansList) {
        var answerObject = {}
        var ansQIDList = Object.keys(ansList)
        ansQIDList.forEach((ansQID, index) => {
            answerObject[ansQID] = ansList[ansQID][ansQID]
        })
        return answerObject;
    }

    async dataURItoBlob(dataURI, form, handle) {
        let blob = await (await fetch(dataURI)).blob();
        form.append('file', blob, handle);
        return blob;
    }

    updateQuestionData(questionData, dataVersion, bodyTags, index = this.state.currentIndex) {
        Redux.updateQuestionRenderState(true);
        Redux.updateReduxCurrentAnswer({});
        Redux.updateReduxQuestionList(questionData);
        Redux.updateReduxAnswerList({});
        Redux.updateReduxCurrentQuestion(questionData[index]);
        localStorage.setItem('dataVersion', JSON.stringify(dataVersion));
        localStorage.setItem('bodyTags', JSON.stringify(bodyTags));
        this.setState({
            questionList: questionData,
            answerList: {},
            ansList: {},
            qType: questionData[index]['qtype'],
            qData: questionData[index],
            ansData: {},
            dataVersion: dataVersion,
            bodyTags: bodyTags,
            currentIndex: index,
            enableNextQ: false,
            enablePreviousQ: false,
            hasSubqs: false,
            render: true,
        });
    }

    moveToNextQuestion(qList = this.state.questionList, ansList = this.state.answerList, lastQId = this.state.lastQId) {
        //check chief complaints 
        if (qList[this.state.currentIndex] && qList[this.state.currentIndex]['rskey'] && !this.state.fromReview) {
            qList[this.state.currentIndex]['rskey'] === 'chiefComplaint' ?
                MoengageUtils.trackMoengageEvents('econsult_chief_complain_filled') : '';
        }
        var nextIndex = this.state.currentIndex + 1, currentIndex = this.state.currentIndex,
            isLastQ = this.getCurrentQId() == lastQId;
        ansList = setConsultationAnswer(qList[currentIndex], ansList, this.getCurrentAns());
        if (isLastQ) {
            this.updateReviewAnswer(qList, ansList)
        } else if (qList[nextIndex]) {
            var checkIsNextEnable = false;
            if (ansList[qList[nextIndex]['qid']])
                checkIsNextEnable = true
            Redux.updateQuestionRenderState(true);
            Redux.updateReduxCurrentQuestion(qList[nextIndex]);
            Redux.updateReduxCurrentAnswer(ansList[qList[nextIndex]['qid']] ?? {});
            Redux.updateReduxAnswerList(ansList);
            this.setState({
                enableNextQ: checkIsNextEnable,
                enablePreviousQ: Object.keys(ansList).length > 0,
                answerList: ansList,
                qType: qList[nextIndex]['qtype'],
                qData: qList[nextIndex],
                ansData: ansList[qList[nextIndex]['qid']] ?? {},
                currentIndex: nextIndex,
                render: true,
            });
        } else this.updateReviewAnswer(qList, ansList)
    }

    populateSubQuestionsAndMoveToNext(subQuestionList) {
        var qList = this.state.questionList,
            ansList = this.state.answerList,
            nextIndex = this.state.currentIndex + 1,
            currentIndex = this.state.currentIndex,
            subsQListLastIndex = Object.keys(subQuestionList).length - 1;
        for (var i = 0; i < Object.keys(subQuestionList).length; i++) {
            qList.splice(nextIndex + i, 0, subQuestionList[i]);
        }
        ansList = setConsultationAnswer(qList[currentIndex], ansList, this.getCurrentAns());
        let dataVersion: any = localStorage.getItem('dataVersion');
        let bodyTags: any = localStorage.getItem('bodyTags');

        if (this.checkIsReview() && !this.checkReviewLastQAnswer(ansList, this.getCurrentQ()))
            this.props.navigation.replace(ScreenRoute.review_answer, { dataVersion: JSON.parse(dataVersion), bodyTags: JSON.parse(bodyTags) });
        else {
            Redux.updateReduxCurrentQuestion(qList[nextIndex]);
            Redux.updateReduxCurrentAnswer({});
            Redux.updateQuestionRenderState(true);
            Redux.updateReduxQuestionList(qList);
            Redux.updateReduxAnswerList(ansList);
            this.setState({
                qType: qList[nextIndex]['qtype'],
                qData: qList[nextIndex],
                currentIndex: nextIndex,
                questionList: qList,
                answerList: ansList,
                ansData: {},
                hasSubqs: false,
                enableNextQ: false,
                enablePreviousQ: Object.keys(ansList).length > 0,
                lastQId: this.checkIsReview() ? subQuestionList[subsQListLastIndex]['qid'] : this.state.lastQId,
                render: true,
            });
        }
    }

    loadPreviousQuestionData() {
        var previousIndex = this.state.currentIndex - 1, currentIndex = this.state.currentIndex,
            qList = this.state.questionList, ansList = this.state.answerList;
        ansList = setConsultationAnswer(qList[currentIndex], ansList, this.getCurrentAns());

        if (this.state.currentIndex == 0) console.log('not valid');
        else {
            Redux.updateQuestionRenderState(true);
            Redux.updateReduxCurrentQuestion(qList[previousIndex]);
            Redux.updateReduxCurrentAnswer(ansList[qList[previousIndex]['qid']]);
            Redux.updateReduxAnswerList(ansList);
            this.setState({
                // enableNextQ: false,
                enablePreviousQ: Object.keys(ansList).length > 0,
                ansList: ansList,
                qType: qList[previousIndex]['qtype'],
                qData: qList[previousIndex],
                ansData: ansList[qList[previousIndex]['qid']],
                currentIndex: previousIndex,
                render: true,
            })
        }
    }

    updateReviewAnswer(qList = this.state.questionList, ansList = this.state.answerList) {
        Redux.updateReduxAnswerList(ansList);
        Redux.updateReduxQuestionList(qList);
        let dataVersion: any = localStorage.getItem('dataVersion')
        let bodyTags: any = localStorage.getItem('bodyTags')

        this.props.navigation.replace(ScreenRoute.review_answer,
            { dataVersion: JSON.parse(dataVersion), bodyTags: JSON.parse(bodyTags) });
    }

    removeSubsAnswer() {
        const reduxState = store.getState();
        var qData = this.getCurrentQ(), ansData = this.getCurrentAns(), qID = this.getCurrentQ()['qid'], imageData = reduxState.consultImageData, isImagePicker = false,
            isSubAnswered = true, ansList = this.state.answerList, qList = this.state.questionList,
            ansQIDList = Object.keys(ansList), lastQId = this.state.lastQId, subQList = [];

        if (qData['subq'] && ansData && getConsultationAnsValue(qData, ansData))
            subQList = qData['subq'][getConsultationAnsValue(qData, ansData)]
        var subQData = qList.filter(question => checkSubsIDExist(qID, question['qid']));

        if (subQList && subQList.length > 0) {
            subQList.forEach((subQId) => {
                if (subQData && subQData.length > 0) {
                    var hasMatched = false
                    subQData.forEach((subQ) => {
                        if (subQ['qid'] == subQId || checkSubsIDExist(subQId, subQ['qid']) || hasMatched) {
                            if (checkSubsIDExist(subQId, subQ['qid'])) {
                                isSubAnswered = isSubAnswered && true
                            }
                            else if ((ansData && getConsultationAnswer(subQ, ansList)
                                && getConsultationAnsValue(subQ, ansData)) || hasMatched) {
                                isSubAnswered = true
                                hasMatched = true
                            }
                            else isSubAnswered = false;
                        } else isSubAnswered = false;
                    })
                } else isSubAnswered = false;
            })
        } else isSubAnswered = false;

        if (subQData && subQData.length > 0) {
            subQData.forEach((subQ) => {
                if (subQ['qtype'] == 'IMPIMG')
                    isImagePicker = true
            })
        }
        if (!this.state.hasSubqs || !isSubAnswered) {
            ansQIDList.forEach((ansId) => {
                if (ansId.startsWith(qID) && ansId != qID) {
                    this.checkIsReview() ? lastQId = qID : null
                    delete ansList[ansId];
                    if (isImagePicker) {
                        imageData[ansId] = [];
                        Redux.updateReduxImageList(imageData);
                    }
                }
            })
            qList = qList.filter(question => !checkSubsIDExist(qID, question['qid']));
        }
        Redux.updateReduxQuestionList(qList);
        Redux.updateReduxAnswerList(ansList);
        this.setState({
            questionList: qList,
            answerList: ansList,
            lastQId: lastQId,
        });
        var response = {
            hasSubqs: this.state.hasSubqs && !isSubAnswered,
            lastQId: lastQId,
            qList: qList,
            ansList: ansList
        }
        return response;

    }

    checkAnswerInput(qData, ansData) {
        var isInputValid = false, hasSubqs = false;
        if (ansData && qData) {
            if (Object.keys(ansData).length == 0) {
                if (qData.mandatory) isInputValid = false;
                else isInputValid = true;
            } else {
                if (qData['qtype'] == 'SSUB') {
                    isInputValid = ansData[qData['qid']] && this.checkTextInputValidity(qData, getConsultationAnsValue(qData, ansData))
                } else if (qData['qtype'] == 'SSUBWTNA') {
                    isInputValid = ansData[qData['qid']] && this.checkSSUBWTNAInput(qData, ansData);
                } else if (qData['qtype'] == 'SCTXT' || qData['qtype'] == 'SCIMG') {
                    hasSubqs = this.checkSubqsOption(qData, ansData);
                    if (qData.options) qData.options.forEach((option) => {
                        if (ansData[qData['qid']] && option.value == getConsultationAnsValue(qData, ansData)) {
                            if (option.too || option.text)
                                isInputValid = ansData[qData['qid']] && ansData[qData['qid']]['textInput'] &&
                                    this.checkTextInputValidity(qData,
                                        getConsultationAnsTextInputValue(qData, ansData), option['vmfactor']);
                            else isInputValid = true;
                        }
                    })
                } else if (qData['qtype'] == 'MCTXT' || qData['qtype'] == 'MCIMG') {
                    hasSubqs = this.checkSubqsOption(qData, ansData);
                    if (ansData[qData['qid']] && getConsultationAnsValue(qData, ansData).length != 0)
                        isInputValid = true;
                    else isInputValid = false
                } else if (qData['qtype'] == 'IMPIMG') {
                    if (ansData[qData['qid']] && getConsultationAnsValue(qData, ansData).length != 0)
                        isInputValid = true;
                } else isInputValid = false;
            }
        }
        this.setState({
            enableNextQ: isInputValid,
            hasSubqs: hasSubqs,
            enablePreviousQ: Object.keys(this.state.answerList).length > 0,
            ansData: ansData, qData: qData
        })
    }

    checkSubqsOption(qData, ansData) {
        var hasSubqs = false;
        if (qData.subq) {
            if (qData.qtype == 'SCTXT')
                if (qData.subq[getConsultationAnsValue(qData, ansData)]) {
                    this.setState({
                        subqOption: getConsultationAnsValue(qData, ansData)
                    })
                    hasSubqs = true;
                }
            if (qData.qtype == 'MCTXT')
                getConsultationAnsValue(qData, ansData).forEach((option) => {
                    if (qData.subq[option]) {
                        this.setState({ subqOption: option })
                        hasSubqs = true;
                    }
                })
        }
        if (qData.subq && ansData[qData['qid']] && hasSubqs)
            return true
        else {
            return false
        }
    }

    checkTextInputValidity(qData, textInput = '', vmfactor = 1) {
        if (qData.mandatory && textInput.length == 0)
            return false;
        else if (qData.limits) {
            if (textInput <= qData.limits.high && textInput >= qData.limits.low) {
                if (qData.constraints) {
                    if (qData.constraints[0]['name'] == 'age') {
                        const memberOffsetAgeInDays = this.state.consultationParams.selectedMember.age * 365
                            - qData.constraints[0]['offsetBy'];
                        const userInput = parseInt(textInput) * vmfactor;
                        return userInput < memberOffsetAgeInDays;
                    }
                } return true;
            } else return false;
        } return true;
    }

    checkReviewLastQAnswer(ansList, qData) {
        var isAnswered = false;
        if (ansList[qData['qid']])
            isAnswered = true;
        return isAnswered;
    }

    getReviewLastQId(qData, ansData) {
        const ansValue = getConsultationAnsValue(qData, ansData);
        var lastQId = qData['qid'];
        if (qData.subq && qData.subq[ansValue]) {
            const subQList: [] = qData.subq[ansValue];
            var maxQId = qData['qid'];
            subQList.forEach((qId) => {
                if (qId > maxQId)
                    maxQId = qId;
            })
            lastQId = maxQId
        }
        return lastQId;
    }

    checkSSUBWTNAInput(qData, ansData) {
        if (getConsultationAnsValue(qData, ansData) == qData['naValue'])
            return true;
        else return this.checkTextInputValidity(qData, getConsultationAnsValue(qData, ansData))
    }

    getCurrentAns() { return this.state.ansData }
    getCurrentQ() { return this.state.qData }
    getCurrentQId() { return this.state.qData['qid'] }
    checkIsReview() { return this.state.fromReview }
    checkIsNextEnable() {
        if (getConsultationAnsValue(this.getCurrentQ(), this.getCurrentAns()) &&
            getConsultationAnsValue(this.getCurrentQ(), this.getCurrentAns()).length != 0) {
            return this.state.enableNextQ;
        } else return false;
    }
    checkNextButton() { return this.state.qData['qid'] != this.state.lastQId } // else Review
    checkNextButtonFromReview() { return this.state.hasSubqs } // else Submit
    checkPreviousButton() { return this.state.currentIndex !== 0 && Object.keys(this.state.answerList).length > 0; }
    checkPreviousButtonFromReview() {
        return this.state.currentIndex !== 0 && Object.keys(this.state.answerList).length > 0 &&
            this.state.questionList[this.state.currentIndex - 1]['qid'].substring(0, 2) === this.state.questionList[this.state.currentIndex]['qid'].substring(0, 2)
    }

    getCurrentReviewQuestionIndex(qList, qData) {
        var cINdex = 0;
        qList.forEach((question: any, index) => {
            if (question['qid'] == qData['qid']) cINdex = index;
        }); return cINdex;
    }

    render() {
        return <KeyboardAvoidingView>

            <CommonHeader navigation={this.props.navigation} confirmBackpress={true} alertOkColor={AppTheme.color.red.highlight}
                alertCancelColor={AppTheme.color.primary} showWarning={true} alertTitle={'You will lose your progress. Is that OK?'}
                alertCancelText={'NO'} alertOkText={'YES'} title='E-Consult' />

            <GestureRecognizer style={{ flex: 1, backgroundColor: this.state.backgroundColor, marginTop: AppTheme.headerHeight }}> {
                this.state.render || this.state.enablePreviousQ ? <View>

                    <View style={{
                        height: 8, backgroundColor: AppTheme.color.blue.bg,
                        borderRadius: 4, marginVertical: 24, width: AppTheme.appWidth - 32, marginHorizontal: 16
                    }}>
                        <View style={{
                            height: 8, backgroundColor: AppTheme.color.primary,
                            borderRadius: 4, width: (AppTheme.appWidth - 32) * ((this.checkIsNextEnable() ? 1 + this.state.currentIndex : this.state.currentIndex) / this.state.questionList.length)
                        }} />
                    </View>

                    <View style={[AppStyles.flexRowCenter, {
                        borderRadius: 8, paddingVertical: 12, paddingHorizontal: 28, marginHorizontal: 16,
                        backgroundColor: AppTheme.color.green.lightPrimary
                    }]}>
                        <Image resizeMode={'stretch'} source={{
                            uri: getImagePath('/images/answer.svg'),
                            height: 20, width: 25
                        }} />
                        <Text style={{ fontSize: 12, marginLeft: 8, width: AppTheme.appWidth * 0.80, color: AppTheme.color.green.primary }}>
                            Answer these questions so that doctor understands your case better.</Text>
                    </View>

                    {/* <View style={styles.inputCardHead}>
                            <ImageBackground source={{
                                uri: getFilePath('/images/questionnaire/' + this.state?.consultationParams?.selectedCategory?.iconAsset),
                                height: AppTheme.appWidth * 0.3, width: AppTheme.appWidth
                            }} style={{ height: AppTheme.appWidth * 0.3, width: AppTheme.appWidth, borderRadius: 4 }}>
                                <View style={{ padding: 15 }}>
                                    <Text><Text style={styles.problemLabel}>{this.state?.consultationParams?.selectedCategory?.caseCode}
                                    </Text> <Text style={AppStyles.mdText}>consultation</Text>  </Text>
                                    <Text style={[AppStyles.mdText, { paddingTop: 4 }]}> for {this.state?.consultationParams?.selectedMember?.name}</Text>
                                </View>
                            </ImageBackground>
                            <View style={{ padding: 15, width: AppTheme.appWidth * 0.75 }}>
                                <Text style={styles.problemLabel}>{this.state?.consultationParams?.selectedCategory?.caseCode}
                                </Text>
                                <Text numberOfLines={1} ellipsizeMode='head' style={[AppStyles.mdText,]}> consultation for<Text style={{ fontSize: 20, fontWeight: '600', color: '#b3000' }}> {this.state?.consultationParams?.selectedMember?.name}</Text></Text>
                            </View>
                            <View style={{ paddingTop: 6, paddingBottom: 5, paddingRight: 6 }}>
                                <Image source={{ uri: getImagePath('/images/questionnaire/' + this.state?.consultationParams?.selectedCategory?.iconAsset.replace('webp', 'svg')) }}
                                    style={{ width: 75, height: 75, }} />
                            </View>
                        </View> */}

                    <View style={{ marginBottom: 30 }}>
                        {
                            this.state.qType == 'SSUBWTNA' ?
                                <InputFeildWithNAFunc /> :
                                this.state.qType == 'SSUB' ?
                                    <InputFeildFunc /> :
                                    this.state.qType == 'SCTXT' ?
                                        <SingleChoiceFunc /> :
                                        this.state.qType == 'MCTXT' ?
                                            <MultipleChoiceFunc /> :
                                            this.state.qType == 'SCIMG' ?
                                                <SingleChoiceFunc /> :
                                                this.state.qType == 'MCIMG' ?
                                                    <MultipleChoiceFunc /> :
                                                    this.state.qType == 'IMPIMG' ?
                                                        <ImagePicker /> :
                                                        this.state.qType == 'MSLWP' ?
                                                            <ImageWithPointer /> :
                                                            <View>{this.state.qType}</View>

                        }
                    </View>

                    <View style={{ position: "fixed", bottom: 0, padding: 16, marginHorizontal: 0, width: AppTheme.appWidth, shadowOpacity: 0.4, shadowRadius: 6, zIndex: 20, backgroundColor: AppTheme.color.white }}>
                        {
                            (this.checkPreviousButton() && !this.checkIsReview()) || this.checkPreviousButtonFromReview() ? <View
                                style={[AppStyles.flexRowCenter]}>
                                <TouchableOpacity onPress={() => { this.loadPreviousQuestionData() }}
                                    style={{
                                        paddingVertical: 16, width: (AppTheme.appWidth - 52) * 0.5, marginRight: 20,
                                        borderRadius: 4, borderWidth: 2, borderColor: AppTheme.color.primary
                                    }}><Text
                                        style={[styles.btnText, { color: AppTheme.color.primary }]}>PREVIOUS</Text></TouchableOpacity>
                                <TouchableOpacity onPress={this.checkIsNextEnable() ? () => {
                                    this.checkSubqsAPICall();
                                } : () => { }}
                                    style={{
                                        paddingVertical: 16, width: (AppTheme.appWidth - 52) * 0.5, borderRadius: 4,
                                        backgroundColor: this.checkIsNextEnable() ? AppTheme.color.primary : AppTheme.color.grey.disable,
                                        borderColor: this.checkIsNextEnable() ? AppTheme.color.primary : AppTheme.color.grey.disable
                                    }}>
                                    <Text style={[styles.btnText, { color: AppTheme.color.white }]}>
                                        {this.checkIsReview() ? this.checkNextButtonFromReview() ?
                                            'NEXT' : 'SUBMIT' : this.checkNextButton() ? 'NEXT' : 'REVIEW'}
                                    </Text>
                                </TouchableOpacity>
                            </View> : <TouchableOpacity onPress={this.checkIsNextEnable() ? () => {
                                this.checkSubqsAPICall();
                            } : () => { }}
                                style={{
                                    paddingVertical: 16, width: AppTheme.appWidth - 32, borderRadius: 4,
                                    backgroundColor: this.checkIsNextEnable() ? AppTheme.color.primary : AppTheme.color.grey.disable,
                                    borderColor: this.checkIsNextEnable() ? AppTheme.color.primary : AppTheme.color.grey.disable
                                }}>
                                <Text style={[styles.btnText, { color: AppTheme.color.white }]}>{this.checkIsReview() ? this.checkNextButtonFromReview() ?
                                    'NEXT' : 'SUBMIT' : this.checkNextButton() ? 'NEXT' : 'REVIEW'}</Text>
                            </TouchableOpacity>
                        }
                    </View>


                </View> : <View>
                </View>
            }
            </GestureRecognizer>

            <ActionPopup showPopUp={this.state.showExitFlowPopup}
                modalData={ModalContent.QuestionaireBackpress}
                setPopUpOnCancel={() => this.setExitFlowPopup({ active: false })}
                setPopUpOnOk={() => this.exitFlowAction()} />

        </KeyboardAvoidingView>

    }
}

const styles = StyleSheet.create(addFontFamilylato({
    inputCardHead: {
        flex: 1,
        flexDirection: "row",
        justifyContent: "space-between",
        backgroundColor: '#f5f5f5',
        // paddingHorizontal: 16,
        width: AppTheme.appWidth
    },
    problemLabel: {
        fontSize: 20,
        color: '#0082ff',
        // paddingLeft: 4
    },
    quesInput: {
        borderColor: 'f5f5f5',
        borderWidth: 1,
        borderRadius: 4,
        padding: 4
    },
    nextButton: {
        width: 75,
    },
    btnText: {
        fontSize: 14,
        fontWeight: '600',
        alignContent: 'center',
        alignText: 'center',
        textAlign: 'center'
    }

}))

